<template>
    <gusa-container container-class="pt-0">
        <div style="display: flex; flex-direction: row">
            <img style="width: 130px; margin-bottom: 1%" src="../../../assets/logos/getac-logo.svg" />
            <div class="text-h7 nav-font pl-3" style="margin-top: 1.3%">CREATE RMA</div>
        </div>
        <v-divider style="margin-bottom: 1%; border-color: gray" />
        <v-container class="download-label-container">
            <base-info-card
                v-if="!rmaCreated"
                class="my-2"
                title="RMA has not been created"
                text="If you feel you reached this page in error, please reach out to support"
                color="primary"
            >
            </base-info-card>
            <div v-else>
                <base-info-card
                    data-cy="success-rma-created"
                    title="Your RMA has been created"
                    color="primary"
                    class="my-2"
                />
                <div v-for="(rma, index) in rmaNumbers" :key="index" class="d-flex flex-column">
                    <base-btn
                        v-if="!!createRmaResponse.rmaList[index].label"
                        class="my-2"
                        data-cy="btn-download-label"
                        color="primary"
                        :block="$vuetify.breakpoint.smAndDown"
                        :class="!$vuetify.breakpoint.smAndDown ? 'mr-1' : 'mt-1'"
                        outlined
                        @click="downloadLabel(index)"
                    >
                        Download Shipping Label of RMA# {{ rma }}
                    </base-btn>
                </div>
                <base-card title="Disclaimer" />
                <!--base-body>
                    This shipping label will expire in 30 days from the date of issue. Please ensure all information is
                    and current before use. For any questions or concerns, please contact Getac Support prior to
                    expiration.
                </base-body-->
                <base-body v-if="advanceExchange" data-cy="advance-exchange-shipment" space="3">
                    A new device will be shipped to you with a return label to send your current device back.
                </base-body>
                <base-body v-if="isShipError" data-cy="error-on-shipment" space="3">
                    There was a error during shipping label creation. If you don't receive a label via email within 24
                    hours: please contact
                    <a
                        :href="
                            'mailto:getacsupport_us@getac.com?subject=Error during label creation for RMA# ' +
                            rmaNumbers
                        "
                        >Getac Service</a
                    >
                    with your rma numbers, and a label will be provided.
                </base-body>
                <base-body v-if="isShipError" data-cy="international-email" space="3">
                    If this is a international RMA, please contact
                    <a
                        :href="
                            'mailto:getacsupport_us@getac.com?subject=I need a international label for RMA# ' +
                            rmaNumbers
                        "
                        >Getac Service</a
                    >
                    with your rma number, and a label will be provided.
                </base-body>
            </div>

            <base-info-card v-if="!!rmaNumbers" data-cy="rma-created-headline" :title="`RMA#  Summary`" color="primary">
                <base-card-summary class="base-summary" tile flat :data-map="summaryMap" :all-data="userInput">
                    <template v-slot:rmaNumbers>
                        {{ rmaNumbers }}
                    </template>
                </base-card-summary>
            </base-info-card>

            <v-col>
                <base-btn
                    color="secondary"
                    data-cy="btn-create-another-rma"
                    small
                    :block="$vuetify.breakpoint.smAndDown"
                    :class="!$vuetify.breakpoint.smAndDown ? 'mr-10' : 'mt-1'"
                    outlined
                    @click="$emit('createNewRma')"
                >
                    Need to Create a new Service Request?
                </base-btn>
            </v-col>
        </v-container>
    </gusa-container>
</template>

<script>
import { poDownload } from '@/api'
import RepairTypeMixin from '@/mixins/repair_type'
import GusaContainer from '@/layouts/home/container.vue'

export default {
    name: `DownloadLabelStep`,
    components: {
        GusaContainer
    },
    mixins: [RepairTypeMixin],
    props: {
        createRmaResponse: {
            type: Object,
            default: () => {}
        },
        international: {
            type: Boolean,
            default: false
        },
        userInput: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            summaryMap: [
                {
                    mainTitle: `RMA Info`,
                    mainItems: [
                        {
                            subTitle: ``,
                            subItems: [
                                {
                                    title: `RMA #`,
                                    path: `rmaNumbers`,
                                    override: true
                                },
                                {
                                    title: `Primary Fault`,
                                    path: `problemData.primaryFault`
                                },
                                {
                                    title: `Problem`,
                                    path: `problemData.problem`
                                },
                                {
                                    title: `User Notes`,
                                    path: `problemData.initialNotes`
                                },
                                {
                                    title: `User including Hard Case`,
                                    path: `problemData.acc.hardCase`
                                },
                                {
                                    title: `User including AC Power`,
                                    path: `problemData.acc.acPower`
                                },
                                {
                                    title: `User including battery`,
                                    path: `problemData.acc.battery`
                                },
                                {
                                    title: `User including storage (HDD/SSD)`,
                                    path: `problemData.acc.storage`
                                },
                                {
                                    title: `Windows System Re-Image Approval`,
                                    path: `problemData.permissions.reimage`
                                },
                                {
                                    title: `BIOS Upgrade Approval`,
                                    path: `problemData.permissions.biosFirmware`
                                }
                            ]
                        },
                        {
                            subTitle: `Unit Details`,
                            subItems: [
                                {
                                    title: `Serial #`,
                                    path: `unitData.serials`
                                },
                                {
                                    title: `Model`,
                                    path: `unitData.model`
                                },
                                {
                                    title: `Warranty Type`,
                                    path: `unitData.warrantyType`
                                }
                            ]
                        }
                    ]
                },
                {
                    mainTitle: `Contact Info`,
                    mainItems: [
                        {
                            subTitle: ``,
                            subItems: [
                                {
                                    title: `First Name`,
                                    path: `contactData.firstName`
                                },
                                {
                                    title: `Last Name`,
                                    path: `contactData.lastName`
                                },
                                {
                                    title: `Email`,
                                    path: `contactData.email`
                                },
                                {
                                    title: `Phone`,
                                    path: `contactData.phone`
                                },
                                {
                                    title: `Orginization`,
                                    path: `contactData.company`
                                },
                                {
                                    title: `Position`,
                                    path: `contactData.position`
                                }
                            ]
                        },
                        {
                            subTitle: `Address`,
                            subItems: [
                                {
                                    title: `Address 1`,
                                    path: `addressData.line1`
                                },
                                {
                                    title: `Address 2`,
                                    path: `addressData.line2`
                                },
                                {
                                    title: `City`,
                                    path: `addressData.city`
                                },
                                {
                                    title: `State`,
                                    path: `addressData.state`
                                },
                                {
                                    title: `Country`,
                                    path: `addressData.country`
                                },
                                {
                                    title: `Zip/Postal Code`,
                                    path: `addressData.postalCode`
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    computed: {
        shippingError() {
            return !!this.createRmaResponse.shippingError
        },
        rmaNumbers() {
            return this.createRmaResponse.rmaList ? this.createRmaResponse.rmaList.map((rma) => rma.rmaNumber) : []
        },
        rmaCreated() {
            return this.createRmaResponse.rmaList ? this.createRmaResponse.rmaList.length > 0 : false
        },
        isShipError() {
            const noLabelOrInvoice = this.createRmaResponse.rmaList.some((rma) => !rma.label && !rma.commercialInvoice)
            return this.shippingError && noLabelOrInvoice
        }
    },
    methods: {
        async downloadCommercialInvoice() {
            this.$emit(`downloadCommercialInvoice`, this.createRmaResponse.commercialInvoice)
        },

        async downloadLabel(index) {
            this.$emit(`downloadLabel`, this.createRmaResponse.labels[index])
        },
        async getPoFile() {
            await poDownload({ filename: this.filename })
        }
    }
}
</script>

<style>
.theme--light.v-application .base-summary .text--primary {
    color: white !important;
}
.download-label-container p {
    color: white !important;
}
</style>
